module.exports = __webpack_public_path__ + "assets/img/share-bg1.e19c7319.png";